module.exports = __webpack_public_path__ + "static/media/b-model.a59363bf.png";